import * as React from 'react'
import { inject, observer } from 'mobx-react'
import TextArea from 'src/components/atoms/input/TextArea'
import Link from 'src/components/atoms/input/buttons/Link'
import { ConfiguratorBox } from 'src/components/containers/configurator/ConfiguratorBox'
import { StoreProps } from 'src/stores'

interface Props extends StoreProps {
  index?: number
}

interface State {
  saved: boolean
  value: string
}

@inject('confStore')
@observer
export default class OfferCommentBox extends React.Component<Props, State> {
  constructor(props: StoreProps) {
    super(props)
    const { confStore } = props
    this.state = {
      saved: false,
      value: confStore.getOffer.comments || ''
    }
  }

  save = () => {
    const { confStore } = this.props
    const { value } = this.state
    confStore.setComment(value, () => {
      this.setState({ saved: true })
    })
  }

  handleChange = (e) => {
    this.setState({ saved: false, value: e.target.value })
  }

  render() {
    const { index } = this.props
    const { saved, value } = this.state
    return (
      <ConfiguratorBox collapsable title={`${index}. Weitere Anmerkungen`} idLabel={`expand-arrow-offer-comment`}  >
        <TextArea
          onChange={this.handleChange}
          name='message'
          value={value}
          placeholder='Was wollen Sie uns sonst noch mitgeben?'
        />
        <Link light id={"save-message"} onClick={this.save}>
          {saved ? 'Übernommen \u{2714}' : 'Übernehmen'}
        </Link>
      </ConfiguratorBox>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/configurator/OfferComment.tsx